import React, {useState, useRef, useEffect} from 'react';
import {useSiteMetadata} from '../hooks/use-site-metadata';
import {ThemeProvider} from 'styled-components';
import styled from 'styled-components';
import {Container, Button, Row, Col} from 'react-bootstrap';
import Navbar from './Navbar';
import Sidenav from './Sidenav';
// import {Link} from 'gatsby';
import {useLocation} from '@reach/router';
import '../styles/_main.scss';
import {ChevronUp, ChevronDown} from '@styled-icons/bootstrap';

const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../styles/_variables.scss');
const StyledButton = styled(Button)``;
const MobileMenu = styled(Sidenav)`
  display: block;
  z-index: 1000;

  @media (max-width: 575.98px) {
    padding: 0 1em;
  }
  &.is-active {
    display: none;
  }
  h2,
  button {
    /* display: none; */
  }

  .nav a,
  .nav a:link {
    break-inside: avoid;
    /* color: white; */
    color: ${props => props.theme.black};
    display: block;
    width: 100%;
  }
  .nav a.active,
  .nav a.active:link {
    color: ${props => props.theme.primary};
  }
  .nav {
    h1 {
      font-size: ${props => props.theme.h2FontSize};
    }
    h2 {
      font-size: ${props => props.theme.fontSizeBase};
    }
    p {
      font-size: ${props => props.theme.smallerFontSize};
    }
    a:first-of-type,
    a + a {
      /* padding-top: 14px; */
      margin-bottom: 3rem;
    }
  }
`;

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const Layout = ({children, scheme}) => {
  const {title, description} = useSiteMetadata();
  const [isActive, setActive] = useState('false');
  const location = useLocation();
  const prevLocation = usePrevious(location);

  useEffect(() => {
    if (location !== prevLocation) {
      setActive(false);
    }
  }, [location, prevLocation, setActive]);

  const handleToggle = () => {
    setActive(!isActive);
  };


  return (
    <ThemeProvider theme={theme}>
      <div className={'min-vh-100 d-flex flex-column bg-scheme ' + scheme}>
        <Navbar scheme={scheme} />
        <div className=" d-block">
          <div className="pt-2 pb-2 nav-header">
            <Container>
              <button
                className="border-0 bg-transparent text-primary w-100 text-left pl-0 pr-0"
                onClick={handleToggle}
              >
                <Row className="no-gutters align-items-center">
                  <h1
                    id=""
                    className="cover-title h6 font-weight-normal text-uppercase mt-5 mb-5 p-0"
                  >
                    <span className="d-block mb-1">{description}</span>
                    {title}
                  </h1>
                  <div className="col text-right contents-btn">
                    <StyledButton
                      className="btn btn-primary bg-white float-right d-flex align-items-center "
                    >
                      <span className="text-red">Contents</span>
                      <ChevronUp
                        className={`${isActive ? '' : 'd-none'} `}
                        size="16"
                      />
                      <ChevronDown
                        className={`${isActive ? 'd-none' : ''} `}
                        size="16"
                      />
                    </StyledButton>
                  </div>
                </Row>
              </button>
            </Container>
          </div>
          <MobileMenu
            title={description}
            className={`${
              isActive ? '' : 'is-active'
            } bg-white w-100 position-absolute pt-5 pb-5`}
          />
        </div>
        <div scheme={scheme} className={`${isActive ? 'overlay' : ''} `}>
          {children}
        </div>
      </div>
    </ThemeProvider>
  );
};
